<template>
  <div id="body">
    <menu-item x="1043" y="720">blog</menu-item>
    <menu-item x="1200" y="433" :click="clickSpotify">spotify</menu-item>
    <menu-item x="190" y="410">about me</menu-item>
    <menu-item x="750" y="540" :click="clickTerminal" id="menu-term">terminal</menu-item>
    <div class="term-count">{{ currentTerm }}</div>
    <menu-item x="340" y="400">portfolio?</menu-item>
    <menu-item x="1513" y="627" :click="clickGithub">github</menu-item>
    <menu-item x="665" y="190">projects</menu-item>
    <menu-item x="679" y="340" :click="clickDiscord">discord</menu-item>
    <menu-item x="1160" y="740" :click="clickSteam">steam</menu-item>
    <terminal v-for="id in terms" :key="id" :id="id"></terminal>
    <terminal v-for="(meme, index) in memes" :key="index" :meme="meme"></terminal>
    <video autoplay loop id="bg">
      <source src="../assets/milkbg.webm">
    </video>
    <loading time="450"></loading>
  </div>
</template>

<script>
import menuItem from './menu-item'
import terminal from './terminal'
import loading from './loading'

export default {
  name: 'home',
  data () {
    return {
      terms: [],
      currentTerm: 0,
      memes: []
    }
  },
  components: {
    menuItem,
    terminal,
    loading
  },
  methods: {
    clickSpotify () {
      window.open('https://open.spotify.com/user/sojd31f0wqf1nswycyuo8lldd?si=e9bfda9585ad4cf0', '_blank')
    },
    clickTerminal () {
      if (this.currentTerm === 0) {
        this.terms.push(Math.floor(Math.random() * 1000))
      } else {
        let term
        this.$children.forEach(el => {
          if (el.id === this.terms[this.currentTerm - 1]) term = el
        })
        term.minimized = false
        term.focus = true
      }
    },
    clickSteam () {
      window.open('https://steamcommunity.com/id/natsayuki/', '_blank')
    },
    clickGithub () {
      window.open('https://github.com/natsayuki', '_blank')
    },
    clickDiscord () {
      window.open('https://discord.com/users/271330505343893505', '_blank')
    },
    killTerminal (id) {
      this.terms.splice(this.terms.indexOf(id), 1)
      if (this.currentTerm > this.terms.length) this.currentTerm = this.terms.length
    }
  },
  mounted () {
    if (this.$route.query.meme) {
      this.memes.push(this.$route.query.meme)
    }

    document.getElementById('menu-term').addEventListener('wheel', e => {
      if (this.terms <= 0) return
      if (e.wheelDelta >= 0) this.currentTerm++
      else this.currentTerm--
      if (this.currentTerm > this.terms.length) this.currentTerm = 0
      if (this.currentTerm < 0) this.currentTerm = this.terms.length
    })
  }
}
</script>

<style>
#bg {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: -1;
}

.term-count {
  position: fixed;
  top: 565px;
  left: 750px;
  font-size: 20px;
  color: darkgray;
  opacity: .5;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue